import { useState } from "react";
import { useScrollReveal, getRevealClass } from "@/hooks/useScrollReveal";

const missionParagraphs = [
  "現代では、ローカルコミュニティと世界がそれぞれ独自の課題を抱えています。ローカルコミュニティは、労働人口の減少により優れた製品や文化を生産し続けることが難しくなり、供給の途絶えを危惧しています。また、ローカルの価値あるものが世界に届かず、埋もれてしまうこともあります。",
  "一方で、世界は情報過多に陥っており、本当に良いものを見極めることが難しくなっています。ローカルに存在する優れた製品や技術、文化が正しく認識されず、その価値を享受する機会を逃しています。",
  "私たちはこれらの問題を解決するために、ローカルをエンターテインメントとして世界に表現します。ローカルの隠れた輝きを発掘し、その魅力を多くの人々と分かち合うことで、ローカルと世界の双方にウィンウィンの関係を築きます。",
  "この取り組みを通じて、ローカルが再び活気を取り戻し、世界中の人々に新たな価値を届けることを目指します。",
];

export default function MissionSection() {
  const { ref, isVisible } = useScrollReveal();
  const [expanded, setExpanded] = useState(false);

  return (
    <section className="py-3 md:py-6 px-3 md:px-6 lg:px-8 bg-[#f0efef]">
      <div className="max-w-7xl mx-auto bg-white rounded-[20px] overflow-hidden">
        <div className="p-4 md:p-8 lg:p-10">
          {/* Title Area */}
          <div ref={ref} className={getRevealClass(isVisible)}>
            <div className="mb-6 md:mb-10 lg:mb-14">
              <h2 className="text-3xl lg:text-[2.5rem] font-bold text-black tracking-tight leading-tight mb-2 text-center md:text-left">
                Mission
              </h2>
              <p className="text-base text-gray-400 mb-3 text-center md:text-left">私たちの使命</p>
              <p className="text-sm text-gray-500 leading-relaxed text-center md:text-left">
                ローカルの輝きを世界とシェアする
              </p>
            </div>
          </div>

          {/* Dark Card with Background Image */}
          <div className="relative text-white rounded-[24px] overflow-hidden">
            <img
              src="https://static.readdy.ai/image/8da10c853ee44f0b201c0b84a1169777/30b4ee6c5304f103ca1db2ee0cbd4b26.jpeg"
              alt="Mission Background"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50" />
            <div className="relative z-10 p-5 md:p-12 lg:p-16">
              <h3
                className="text-2xl md:text-3xl lg:text-4xl font-semibold mb-4 md:mb-8 tracking-wide text-center md:text-left text-[#C1CF13]"
                style={{ fontFamily: "'Noto Serif JP', serif", fontWeight: 700 }}
              >
                「ローカルの輝きを世界とシェアする」
              </h3>

              {!expanded ? (
                <div className="flex justify-center md:justify-start">
                  <button
                    onClick={() => setExpanded(true)}
                    className="inline-flex items-center gap-3 border border-white/70 text-white text-xs md:text-sm tracking-[0.2em] px-8 py-3.5 hover:bg-white hover:text-black transition-all duration-300 cursor-pointer whitespace-nowrap"
                    style={{ fontFamily: "'Noto Serif JP', serif" }}
                  >
                    続きを読む
                    <i className="ri-arrow-down-line" />
                  </button>
                </div>
              ) : (
                <div className="space-y-5 text-sm md:text-[15px] text-white/90 leading-[1.9] text-center md:text-left transition-opacity duration-500">
                  {missionParagraphs.map((paragraph, i) => (
                    <p key={i}>{paragraph}</p>
                  ))}
                  <div className="flex justify-center md:justify-start pt-2">
                    <button
                      onClick={() => setExpanded(false)}
                      className="inline-flex items-center gap-3 border border-white/70 text-white text-xs md:text-sm tracking-[0.2em] px-8 py-3.5 hover:bg-white hover:text-black transition-all duration-300 cursor-pointer whitespace-nowrap"
                      style={{ fontFamily: "'Noto Serif JP', serif" }}
                    >
                      閉じる
                      <i className="ri-arrow-up-line" />
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}